<ng-container *ngIf="!!tab">
  <div class="container">
    <div class="row" *ngFor="let row of tab.rows">
      <ng-container *ngFor="let cell of row.cells">
      <div class="{{ !!cell.style ? cell.style : 'col' }} cell" [class.px-0]="!showCellPadding">
        <ng-container *ngFor="let box of cell.boxes">
          <ds-cris-layout-box-container [box]="box" [item]="item"></ds-cris-layout-box-container>
        </ng-container>
      </div>
      </ng-container>
    </div>
  </div>
</ng-container>
